import { createFileRoute } from "@tanstack/react-router";
import {
  IndustryServicePage,
  buildIndustryServiceHead,
} from "@/components/IndustryServicePage";
import { getIndustryServiceCombo } from "@/lib/industryServiceData";

const combo = getIndustryServiceCombo("ppc", "plumbing")!;

export const Route = createFileRoute("/ppc-for-plumbing")({
  head: () => buildIndustryServiceHead(combo),
  component: () => <IndustryServicePage combo={combo} />,
});
